/* Copyright (c) 2021 Paul Nebel */

import PropTypes from 'prop-types';
import React from 'react';
import { BbFormat } from 'bb-chord-symbol';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { parseChord, getRootNote, isMinor } from '../core/utils/chord-parser';

class ChordSymbol extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const { selectedChordSymbol, dynamic } = nextProps;

        const newState = {
            ...prevState,
        };

        if (dynamic) {
            if (selectedChordSymbol != prevState.selectedChordSymbol) {
                newState.chordSymbol = getRootNote(selectedChordSymbol);
                newState.selectedChordSymbol = selectedChordSymbol;
            }
        }

        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
        this.state = {
            chordSymbol: props.chordSymbol,
            selectedChordSymbol: parseChord(props.chordSymbol),
        };
    }

    setupChordSymbol() {
        // Get a context to use for rendering
        const canvas = this.canvasRef.current;
        canvas.width = this.props.width;
        canvas.height = this.props.height;
        const ctx = canvas.getContext('2d');
        ctx.font = this.props.font;
        ctx.fillStyle = this.props.backgroundColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = this.props.color;

        try {
            // Create the renderer instance
            const renderer = new BbFormat(ctx);

            // tweak the chord's pre-layout renderer's config
            renderer.rendererOptions = {
                useShortNamings: true,
            };
            // Render your chord
            let xOffset = 0;
            let yOffset = 0;
            const symbolLength = getRootNote(this.state.selectedChordSymbol).length;
            if (this.props.dynamic) {
                if (symbolLength === 1) {
                    xOffset = 50;
                    yOffset = 15;
                } else if (isMinor(this.state.selectedChordSymbol)) {
                    // xOffset = 30;
                    ctx.font = '100px sans-serif';
                    if (symbolLength == 3) {
                        yOffset = 35;
                    } else {
                        xOffset = 30;
                        yOffset = 40;
                    }
                }
            } else {
                if (symbolLength === 1) {
                    xOffset = 10;
                    yOffset = 2;
                }
            }
            renderer.fillChordSymbol(
                this.state.chordSymbol,
                this.props.x + xOffset,
                this.props.y + yOffset
            );
        } catch (e) {
            // write the error message to the canvas.
            ctx.font = '10px sans-serif';
            ctx.fillText(e.message, this.props.x, this.props.y);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextState.chordSymbol !== this.state.chordSymbol ||
            this.props.color !== nextProps.color ||
            this.props.backgroundColor !== nextProps.backgroundColor
        );
    }

    componentDidUpdate() {
        this.setupChordSymbol();
    }

    // Called after render
    componentDidMount() {
        this.setupChordSymbol();
    }

    render() {
        return <canvas ref={this.canvasRef} />;
    }
}

const mapStateToProps = ({ selectedChordSymbol }) => {
    return {
        selectedChordSymbol,
    };
};

ChordSymbol.propTypes = {
    chordSymbol: PropTypes.string.isRequired,
    font: PropTypes.string,
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    selectedChordSymbol: PropTypes.object,
    dynamic: PropTypes.bool,
};

ChordSymbol.defaultProps = {
    chordSymbol: 'C',
    font: '40px sans-serif',
    backgroundColor: 'white',
    color: 'black',
    width: 300,
    height: 200,
    x: 100,
    y: 200,
    dynamic: true, // indicates whether to respond to selectedChord changed (true = respond)
};

export default connect(mapStateToProps, null)(ChordSymbol);
